import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-2711">
      <section className="py-16 bg-white" data-id="element-2712">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2713">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-2714">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-2715">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-2716">
            {/* Main Pages */}
            <div data-id="element-2717">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2718">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2719">
                <li data-id="element-2720">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2721">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-2722">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2723">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-2724">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2725">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-2726">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2727">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-2728">
                <li data-id="element-2729">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2730">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-2731">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2732">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-2733">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2734">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-2735">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2736">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-2737">
                <li data-id="element-2738">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2739">
                    All Services
                  </Link>
                </li>
                <li data-id="element-2740">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2741">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-2742">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2743">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-2744">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2745">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-2746">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2747">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-2748">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2749">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-2750">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2751">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-2752">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2753">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-2754">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2755">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-2756">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2757">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-2758">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2759">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2760">
                <li data-id="element-2761">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2762">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-2763">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2764">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-2765">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2766">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-2767">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2768">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-2769">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2770">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-2771">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2772">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-2773">
                <li data-id="element-2774">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2775">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-2776">
                  <Link to={`/${lang}/blog/skilky-koshtuyut-implanty-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2777">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-2778">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2779">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-2780">
                  <Link to={`/${lang}/blog/likuvannya-zubiv-uk-bez-strakhovky`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2781">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-2782">
                  <Link to={`/${lang}/blog/zubnyi-bil-london-shcho-robyty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2783">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-2784">
                  <Link to={`/${lang}/blog/viniry-london-shcho-potribno-znaty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2785">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-2786">
                  <Link to={`/${lang}/blog/yak-obraty-stomatologa-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2787">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-2788">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2789">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-2790">
                <li data-id="element-2791">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2792">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-2793">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2794">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-2795">
                <li data-id="element-2796">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2797">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-2798">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2799">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-2800">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2801">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-2802">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-2803">
              <div className="flex items-center gap-2" data-id="element-2804">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-2805" />
                <span data-id="element-2806">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-2807">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-2808">
                <Button size="sm" className="gap-2" data-id="element-2809">
                  <Calendar className="w-4 h-4" data-id="element-2810" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-2811">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2812">
                  <MessageCircle className="w-4 h-4 text-green-600" data-id="element-2813" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-2814">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2815">
                  <Phone className="w-4 h-4" data-id="element-2816" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}